import {inject, Injectable} from '@angular/core';
import {IFCCheck, IfcControllerService} from '../../api';
import {catchError, Observable, shareReplay, throwError} from 'rxjs';
import {StateConfigService} from '../state/state-config.service';

@Injectable({providedIn: 'root'})
export class IfcCheckPrefetchService {
  private ifcControllerService = inject(IfcControllerService);
  private stateConfigService = inject(StateConfigService);

  private checkCache = new Map<string, Observable<IFCCheck>>();

  getCheck(checkId: string): Observable<IFCCheck> {
    const key = this.getCacheKey(checkId);
    const cachedCheck$ = this.checkCache.get(key);
    if (cachedCheck$) {
      return cachedCheck$;
    }

    const check$ = this.ifcControllerService.getCheck1(checkId, this.stateConfigService.getProjectId()).pipe(
      catchError((error) => {
        this.checkCache.delete(key);
        return throwError(() => error);
      }),
      shareReplay(1)
    );
    this.checkCache.set(key, check$);
    return check$;
  }

  prefetch(checkId: string): void {
    this.getCheck(checkId).subscribe({
      error: () => undefined
    });
  }

  clear(): void {
    this.checkCache.clear();
  }

  private getCacheKey(checkId: string): string {
    return `${this.stateConfigService.getProjectId()}:${checkId}`;
  }
}
